import DepreciationImage1 from "url:./Deprecitation_image1.jpeg";
import DepreciationImage2 from "url:./deprecitation_image2.jpeg";
import WBLogo from "url:./WB_Logo.jpeg";

export { DepreciationImage1, DepreciationImage2, WBLogo };
